import React, { useState, useEffect } from 'react';
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
//core components
import TableSpc from "components/TableSpc/TableSpc.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Button from "components/CustomButtons/Button"
import CardIcon from "components/Card/CardIcon.js";
import api from "assets/services/api";
import ModalDesaprovedSpc from "components/ModalDesaprovedSpc/ModalDesaprovedSpc";
import ModalUpdateSpc from "components/ModalUpdateSpc/ModalUpdateSpc";
import ModalAddPaymentSell from 'components/ModalAddPaymentSell/ModalAddPaymentSell';
//imports material
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import Icon from "@material-ui/core/Icon";
import FileUploadIcon from "@material-ui/icons/Publish";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { Input } from '@material-ui/core';

const styles4 = {
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};
const useStyles2 = makeStyles(styles2);
const useStyles4 = makeStyles(styles4);
function ModalViewPayments(props) {
    console.log(props)
    const classes2 = useStyles2();
    const classes4 = useStyles4();
    const id_client = props.props.id
    const social_reason = props.props.social_reason
    const [payments, setPayments] = useState([]);
    const [fileSpc, setFileSpc] = useState(null);
    const [fileSpcName, setFileSpcName] = useState("");
    //controller modals
    const [modal, setModal] = useState(false);
    const [modalAddPaymentSell, setModalAddPaymentSell] = useState(false);
    const [index, setIndex] = useState({ id: 0 });

    useEffect(() => {
        loadPayment();
    }, [])

    function callModalAddPaymentSell(index) {
        if (!modalAddPaymentSell) {
            setModal(true);
        }
        setIndex(index);
        setModalAddPaymentSell(true);
    }
    async function loadPayment() {
        const response = await api.get(`/payment/sell/${props.props.id_client}/${props.props.nf}`)
        console.log(response)
        setPayments(response.data)
    }
    async function addPayments() {
        if (payments.length === 0) {
            console.log('if')
            const addPayment = await api.post('/payment/sell', {
                id_admin: props.props.id_admin,
                nf: props.props.nf,
                first: true
            });
            if (addPayment.status === 200) {
                loadPayment();
            };
        } else {
            console.log('else')
            callModalAddPaymentSell(payments[payments.length - 1])
        }
    };
    async function downloadPayment(fileName) {
        await api
            .get(`/payment/sell/${fileName}`, {
                responseType: "blob",
            })
            .then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = `Comprovante_${social_reason}_${fileName}`
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function getSpc() {
        let teste = [];
        for (let i = 0; i < payments.length; i++) {
            teste[i] = [];
            teste[i].push(payments[i].nf);
            teste[i].push(payments[i].payment_date);
            teste[i].push(payments[i].total_value);
            teste[i].push(payments[i].paid_value);
            teste[i].push(payments[i].remaining_value);
            teste[i].push(i > 0 ?
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridBox">
                        <Form.Group as={Col} controlId="formGridBox">
                            <Tooltip id="tooltip-top" title={"Download SPC"} placement="top" classes={{ tooltip: classes2.tooltip }} >
                                <IconButton aria-label="Done" className={classes2.tableActionButton} onClick={() => downloadPayment(payments[i].file_name)} >
                                    <GetAppIcon
                                        className={classes2.tableActionButtonIconDownload + " " + classes2.edit4 + " " + classes4.tp} />
                                </IconButton>
                            </Tooltip>
                        </Form.Group>
                    </Form.Group>
                </Form.Row> : <></>
            )
            teste[i].push(
            )
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    PAGAMENTOS NF: {props.props.nf}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableSpc
                    tableHeaderColor="primary"
                    tableHead={["Nota Fiscal", "Data", "Valor total", "Valor pago", "Valor restante", "Comprovante"]}
                    tableData={getSpc()}
                />
            </Modal.Body>
            <Modal.Footer>
                <Form.Group as={Col} controlId="formGridName" className="d-flex justify-content-center">
                    <div style={{ display: 'flex', gap: 15, flexDirection: 'row' }}>
                        <Button color="success" onClick={() => addPayments()}>NOVO PAGAMENTO</Button>
                    </div>
                </Form.Group>
            </Modal.Footer>
            <ModalAddPaymentSell key={`pay_${index.id}`} props={index} loadPayment={loadPayment} show={modalAddPaymentSell} onHide={() => setModalAddPaymentSell(false)} />
        </Modal>
    );
}

export default ModalViewPayments;